<template>
  <div class="layerMB" ref="unfold">
    <div>
      <header class="top">
        <p>{{title}}</p>
        <span class="close" @click="close"></span>
      </header>
      <div class="main">
        <p v-show="infoShow">更换新手机号后,原手机号{{oldMobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')}}将不能再作为登录使用！</p>
        <p>
          <span class="silver">新手机号:</span>
          <input type="text" class="field" v-model="newNum" maxlength="11">
        </p>
        <p>
          <span class="silver">短信验证码:</span>
          <input type="text" class="field" v-model="securityNum">
          <button class="button green" @click="send">
            <span v-if="!waitCode">获取短信验证码</span>
            <span v-else>{{wait}}s</span>
          </button>
        </p>
        <p v-show="fail">验证码输入不正确，绑定号码失败！</p>
        <p>
          <button class="button" :class="{'green': (newNum && securityNum), 'gray': (!newNum || !securityNum)}" @click="sure">确定</button>
          <button class="button write" @click="close">取消</button>
        </p>

      </div>
    </div>
    <div class="noticeMask"></div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import fetch from "./../../fetch";
import { clientId, brandId } from "./../../config";

export default {
  data() {
    return {
      newNum: "",
      securityNum: "",
      flag: "",
      wait: 60,
      waitCode: false,
      fail: false,
      title: "更换手机号",
      infoShow: true,
      sendCode: false
    };
  },
  // created() {
  //   console.log(this.oldMobile);
  //   // if (this.oldMobile == "") {
  //   //   this.title = "绑定手机号";
  //   //   this.infoShow = false;
  //   // }
  // },
  props: ["layerMB", "oldMobile"],
  
  watch: {
    layerMB(val) {
      this.$refs.unfold.style.display = "block";
      console.log(this.oldMobile);
      if(this.oldMobile == "未绑定") {
        this.title = "绑定手机号";
        this.infoShow = false;
      }
    }
  },
  methods: {
    ...mapActions(["removeCrumb", "setCrumb", "setUser"]),
    ...mapGetters(["getUser"]),
    close() {
      this.$refs.unfold.style.display = "none";
      this.newNum = "";
      this.securityNum = "";
      this.waitCode = false;
      this.wait = 60;
    },
    send() {
      this.sendCode = true
      var reg = /^1[34578]\d{9}$/; //验证规则
      if (this.newNum == "") {
        this.$toast("手机号不能为空", "error");
        return false;
      } else if (!reg.test(this.newNum)) {
        this.$toast("号码格式不对，或该号码不支持", "error");
        return false;
      } else {
        fetch
          .getsendVerifyCode({
            mobile: this.newNum,
            template_id: 1,
            business_id: brandId
          })
          .then(res => {
            if (!res.data) {
              this.$toast(res.msg);
              return false;
            }
            this.wait = 60;
            this.waitCode = true;
            this.$toast("已发送验证码成功", "right");
            this.countTime();
          });
      }
    },
    countTime() {
      var timer = setInterval(() => {
        if (this.wait == 0) {
          this.waitCode = false;
          clearInterval(timer);
        } else {
          this.wait--;
        }
      }, 1000);
    },
    sure() {
      if (!this.securityNum || !this.newNum) {
        // this.$toast("短信验证码不能为空")
        return false;
      }
      if(!this.sendCode) {
        this.$toast("请输入正确的短信验证码")
        return false;
      }
      fetch
        .getcheckVerifyCode({
          verify_code: this.securityNum,
          business_id: brandId,
          mobile: this.newNum
        })
        .then(res => {
          if (!res) {
            return false;
          }
          this.modifyMB();
        });
    },
    modifyMB() {
      
      fetch
        .getMobile({
          verify_code: this.securityNum,
          business_id: brandId,
          mobile: this.newNum
        })
        .then(res => {
          if (!res.data) {
            this.$toast(res.msg)
            return false;
          }
          let userInfo = this.getUser();
          userInfo.mobile = this.newNum;
          this.setUser(userInfo);

          this.$toast("手机号修改成功", "right");
          this.$emit("sureMobile", this.newNum);
          this.$refs.unfold.style.display = "none";
          this.newNum = "";
          this.securityNum = "";
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// alertMobile.vue?4ca7cd99